import { render, staticRenderFns } from "./ProductConsultList.vue?vue&type=template&id=2e2a18c8&"
import script from "./ProductConsultList.vue?vue&type=script&lang=ts&"
export * from "./ProductConsultList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports